import { PropsWithChildren, useEffect, useState } from 'react';

import { Loader } from '@app-evolution-cms/element-ui';

import { useAuth } from '../../../app/providers/auth';
import { useGetUser } from '../_api/use-get-user';
import { useUserState } from '../_states/user';

export function PermissionsProvider({ children }: PropsWithChildren) {
  const [isSuccess, setIsSuccess] = useState(false);
  const updateUser = useUserState((s) => s.updateUser);
  const user = useUserState((s) => s.user);

  const { logout, userIdentity } = useAuth();
  const { data, status } = useGetUser({ email: userIdentity?.email });

  useEffect(() => {
    if (status === 'success') {
      updateUser({ user: data });
    }
  }, [updateUser, data, status]);

  useEffect(() => {
    setIsSuccess(!!user);
  }, [user]);

  if (status === 'error') logout();
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (isSuccess) return <>{children}</>;

  return (
    <div className="absolute flex size-full items-center justify-center">
      <Loader />
    </div>
  );
}
